import { request } from './index.js'

// 全局信息
export const getGrade = () => request(`api/config/grade`, 'post')


// 老师端
// 老师端
// 老师端
// 老师年级下的课程
export const course_by_teacher = (data) => request(`api/teacher/course/course_by_teacher`, 'post', {
    data: data
})
// 收藏/取消收藏课程
export const collect_course = (data) => request(`api/teacher/course/collect_course`, 'post', {
    data: data
})

// 提问列表
export const question_list = (data) => request(`api/teacher/course/question_list`, 'post', {
    data: data
})
// 提问回复
export const reply_question = (data) => request(`api/teacher/course/reply_question`, 'post', {
    data: data
})

// 课件日志列表
export const courseware_log_list = (data) => request(`api/teacher/course/courseware_log_list`, 'post', {
    data: data
})
// 创建、修改课件日志
export const courseware_log = (data) => request(`api/teacher/course/courseware_log`, 'post', {
    data: data
})
// 课程下的课件
export const courseware_list = (data) => request(`api/teacher/course/courseware_list`, 'post', {
    data: data
})
// 课件日志删除
export const courseware_log_del = (data) => request(`api/teacher/course/courseware_log_del`, 'post', {
    data: data
})

// 期末评价列表
export const evaluate_list = (data) => request(`api/teacher/info/evaluate_list`, 'post', {
    data: data
})
// 添加修改期末评价
export const evaluate = (data) => request(`api/teacher/info/evaluate`, 'post', {
    data: data
})
// 文件上传
export const upload = (data) => request(`api/teacher/file/upload`, 'post', {
    data: data
})
// 删除期末评价
export const evaluate_delete = (data) => request(`api/teacher/course/evaluate_delete`, 'post', {
    data: data
})

// 上课
export const attend_classes = (data) => request(`api/teacher/course/attend_classes`, 'post', {
    data: data
})






// 学校端
// 学校端
// 学校端
// 课程列表
export const school_course_list = (data) => request(`api/admin/course/course_list`, 'post', {
    data: data
})
// 教学日志
export const school_courseware_log_list = (data) => request(`api/admin/course/courseware_log_list`, 'post', {
    data: data
})
// 期末评价
export const school_evaluate_list = (data) => request(`api/admin/course/evaluate_list`, 'post', {
    data: data
})
// 提问列表
export const school_question_list = (data) => request(`api/admin/study/question_list`, 'post', {
    data: data
})